export default __webpack_public_path__ + "static/media/game1.baff8089.webp";